const generateNumberList = (min, max, skip) => {
  const from = Number(min || 0);
  const to = Number(max || 0);
  const step = Number(skip || 0);

  if (from > to || step <= 0) {
    return [];
  }

  const numbers = [];
  let order = 1;

  for (let i = from; i <= to + 1e-9; i += step) {
    const rounded = Number(i.toFixed(2));
    numbers.push({
      id: Date.now() + order,
      value: rounded,
      option: `${rounded}`,
      order: order++
    });
  }

  // Ensure max value is present
  const roundedMax = Number(to.toFixed(2));
  if (!numbers.some((num) => num.value === roundedMax)) {
    numbers.push({
      id: Date.now() + order,
      value: roundedMax,
      option: `${roundedMax}`,
      order: order++
    });
  }

  return numbers;
};

export default generateNumberList;
